import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { SurveyViewModel } from 'src/app/shared/models/surveyview.model';
import { Observable,BehaviorSubject } from 'rxjs';
import { UserModel } from 'src/app/admin/models/group.model';

@Injectable({
  providedIn: 'root'
})
export class UserServiceService {

  constructor(private http: HttpClient) { }

  private _userSource = new BehaviorSubject(new UserModel);
  currentUser= this._userSource.asObservable();

  getSurveyDetails(surveyId: string): Observable<SurveyViewModel> {
    return this.http.get<SurveyViewModel>('../../../../assets/json-data/survey-view.json');
  }


  getUserDeatils(user: UserModel) {
    this._userSource.next(user);
}

}
